import { Api } from '../api';
import { GetViewResponse } from '../cards';
import { letters } from '../endpoints';
import { CreateLettersRequest, GetLettersContentResponse, GetLettersResponse, CreateLetterWithAttachment } from './models';

export class LettersApi extends Api {
  static getLetters = (signal?: AbortSignal) => this.get<GetLettersResponse[]>({ url: letters.letters(), signal: signal });

  static getLetterContent = (id: string, signal?: AbortSignal) =>
    this.get<GetLettersContentResponse>({ url: letters.lettersContent(id), signal: signal });

  static getLettersCount = (signal?: AbortSignal) => this.get<number>({ url: letters.lettersCount(), signal: signal });

  static createLetter = (request: CreateLettersRequest, signal?: AbortSignal) =>
    this.post<CreateLettersRequest, string>({ url: letters.letters(), data: request, signal: signal });

  static createLetterWithAttachments = (request: CreateLetterWithAttachment, signal?: AbortSignal) =>
    this.post({ url: letters.lettersWithAttachments(), data: request, signal: signal });

  static deleteLetter = (id: string, request?: string, signal?: AbortSignal) =>
    this.delete<string, undefined>({ url: letters.deleteLetters(id), data: request, signal: signal });

  static archiveLetter = (id: string, signal?: AbortSignal) => this.post({ url: letters.lettersArchive(id), signal: signal });

  static downloadLetter = (id: string, signal?: AbortSignal) =>
    this.get<GetViewResponse>({ url: letters.lettersDownload(id), responseType: 'blob', signal: signal });

  static viewLetter = (id: string, signal?: AbortSignal) =>
    this.get<GetViewResponse>({ url: letters.lettersView(id), responseType: 'blob', signal: signal });
}
